jQuery.validator.addMethod('rnecodevalid', function (value, element) {
	return this.optional(element) || jQuery('#school-name').val().length > 0;
});
